module.exports = __webpack_public_path__ + "media/src/assets/img/portrait/small/avatar-s-5-99691e543d9e33cf745f6ac56f5800b8.jpg";